import React, { useState, useEffect } from 'react';
import '../AddGardenerForm.css';
import '../Buttons.css';

const SUPSupplierProfileForm = ({ currentSupplier, fetchCurrentSupplier, handleUpdateSupplier }) => {

    // INITIAL STATE � EXACT gardener pattern, EXACT your fields
    const [successMessage, setSuccessMessage] = useState("");
    const [formData, setFormData] = useState({
        name: currentSupplier?.name || "",
        email: currentSupplier?.email || "",
        phone: currentSupplier?.phone || "",
        streetAddress: currentSupplier?.streetAddress || "",
        city: currentSupplier?.city || "",
        province: currentSupplier?.province || "",
        postalCode: currentSupplier?.postalCode || "",
        country: currentSupplier?.country || "",
        logoURL: currentSupplier?.logoURL || "",
        website: currentSupplier?.website || "",
        isNewSupplier: currentSupplier?.isNewSupplier || "",
        addressID: currentSupplier?.addressID ||""
    });

    // SYNC EFFECT � EXACT gardener pattern
    useEffect(() => {
        if (currentSupplier) {
            setFormData({
                name: currentSupplier.name || "",
                email: currentSupplier.email || "",
                phone: currentSupplier.phone || "",
                streetAddress: currentSupplier.streetAddress || "",
                city: currentSupplier.city || "",
                province: currentSupplier.province || "",
                postalCode: currentSupplier.postalCode || "",
                country: currentSupplier.country || "",
                logoURL: currentSupplier.logoURL || "",
                website: currentSupplier.website || "",
                isNewSupplier: currentSupplier?.isNewSupplier || "",
                addressID: currentSupplier?.addressID || ""

            });
        }
    }, [currentSupplier]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const form = e.target.form;
            const index = Array.prototype.indexOf.call(form, e.target);
            form.elements[index + 1]?.focus();
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await handleUpdateSupplier(formData);
            setSuccessMessage("Profile updated successfully");

            // Optional: clear after a few seconds 
            setTimeout(() => setSuccessMessage(""), 3000);
        } catch (err) {
            console.error(err); setSuccessMessage("Failed to update profile");
        }
    };

    return (
        <div className="add-gardener-form">
            <h2 className="form-heading">{currentSupplier.name} Profile</h2>
            <form id="supplier-form" onSubmit={handleSubmit}>

                {/* Supplier Name */}
                <div className="gardener-form-row">
                    <label htmlFor="name" className="gardener-form-label">Supplier Name:</label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                </div>

                {/* Email */}
                <div className="gardener-form-row">
                    <label htmlFor="email" className="gardener-form-label">Email:</label>
                    <input
                        type="text"
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Phone */}
                <div className="gardener-form-row">
                    <label htmlFor="phone" className="gardener-form-label">Phone:</label>
                    <input
                        type="text"
                        name="phone"
                        id="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Street Address */}
                <div className="gardener-form-row">
                    <label htmlFor="streetAddress" className="gardener-form-label">Street Address:</label>
                    <input
                        type="text"
                        name="streetAddress"
                        id="streetAddress"
                        value={formData.streetAddress}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* City */}
                <div className="gardener-form-row">
                    <label htmlFor="city" className="gardener-form-label">City:</label>
                    <input
                        type="text"
                        name="city"
                        id="city"
                        value={formData.city}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Province */}
                <div className="gardener-form-row">
                    <label htmlFor="province" className="gardener-form-label">Province:</label>
                    <input
                        type="text"
                        name="province"
                        id="province"
                        value={formData.province}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Postal Code */}
                <div className="gardener-form-row">
                    <label htmlFor="postalCode" className="gardener-form-label">Postal Code:</label>
                    <input
                        type="text"
                        name="postalCode"
                        id="postalCode"
                        value={formData.postalCode}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Country */}
                <div className="gardener-form-row">
                    <label htmlFor="country" className="gardener-form-label">Country:</label>
                    <input
                        type="text"
                        name="country"
                        id="country"
                        value={formData.country}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Logo URL */}
                <div className="gardener-form-row">
                    <label htmlFor="logoURL" className="gardener-form-label">Logo URL:</label>
                    <input
                        type="text"
                        name="logoURL"
                        id="logoURL"
                        value={formData.logoURL}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {/* Website */}
                <div className="gardener-form-row">
                    <label htmlFor="website" className="gardener-form-label">Website:</label>
                    <input
                        type="text"
                        name="website"
                        id="website"
                        value={formData.website}
                        onChange={handleChange}
                        className="gardener-form-input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                {successMessage && (
                    <div className="success-message">
                        {successMessage}
                    </div>
                )}
                <button type="submit" className="button" >Save Changes</button>
            </form>
        </div>
    );
};

export default SUPSupplierProfileForm;
